// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  min-height: calc(100vh - 50px);
  padding: 2rem 0;
  background-color: #f3f3ea;
  display: flex;
  align-items: center;
}

.form-field-space {
  margin-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/registration/registration.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AACJ;;AAGA;EACE,gBAAA;AAAF","sourcesContent":["form {\r\n    min-height: calc(100vh - 50px);\r\n    padding: 2rem 0;\r\n    background-color: #f3f3ea;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n\r\n.form-field-space{\r\n  margin-top: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
